import { Field, Link, LinkField, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import ChevronLeftIconSvg from 'public/icons/ChevronLeft.svg';

import styles from './BackToHandbookIndex.module.css';

type BackToResourceIndexProps = ComponentProps & {
	fields: {
		HandbookIndexPage: LinkField;
		Description: Field<string>;
	};
};

export default withDatasourceCheck()<BackToResourceIndexProps>(BackToHandbookIndex);

function BackToHandbookIndex(props: BackToResourceIndexProps): JSX.Element {
	return (
		<section className={`${styles.backToResource} padX`}>
			<div className={`${styles.linkContainer} maxWidth `}>
				{props.fields?.HandbookIndexPage.value?.href && (
					<Link field={props.fields?.HandbookIndexPage}>
						<ChevronLeftIconSvg className={styles.chevron}></ChevronLeftIconSvg>
						<Text field={props.fields?.Description} />
					</Link>
				)}
			</div>
		</section>
	);
}
